import React, { useContext } from 'react';
import { Card } from '@mui/material';
import AppointmentCalendar from '../../../components/AppontmentCalendar';
import useTeamDashboardContext from '../context/useTeamDashboardContext';

export default function Progress() {
  const { calendar, handleClickDate } = useContext(useTeamDashboardContext);

  return (
    <Card variant='outlined'>
      <AppointmentCalendar
        appointments={calendar?.data}
        initDate={calendar?.date_month}
        className='ec-container-centered'
        isDisableNavigation
        loading={calendar?.loading}
        onClickDate={handleClickDate}
      />
    </Card>
  );
}
